import React, { useState } from 'react';
import mode from '../helpers/Mode';
import Home from '../icons/Home';

type HomeButtonProps = {
  className?: string;
  locale?: string;
};

const HomeButton = (props: HomeButtonProps) => {
  const { className, locale } = props;
  const [disabled, setDisabled] = useState(false);
  const handleClick = () => {
    setDisabled(true);
    mode.resetKiosk({}, null, true, locale);
  };

  return (
    <button
      aria-label=""
      className={className}
      data-testid="home"
      disabled={disabled}
      onClick={handleClick}
      title=""
      type="button"
    >
      <Home />
    </button>
  );
};

export default HomeButton;
